import fp from 'lodash/fp';
import React from 'react';
import { graphql } from 'react-apollo';
import { Link } from 'react-router-dom';
import { Card, CardImg, CardImgOverlay, CardTitle, Carousel, CarouselCaption, CarouselControl, CarouselIndicators, CarouselItem, Col, Container, Row } from 'reactstrap';
import { compose, mapProps, pure, withProps, withStateHandlers } from 'recompose';
import { routes } from '../../../constants';
import artistsImg from '../../../images/artists.png';
import eventsImg from '../../../images/events.png';
import './home.css';
import query from './home.gql';

const Home = ({
  activeIndex,
  setActiveIndex,
  nextIndex,
  previousIndex,
  data: { artists },
  goTo,
  onExiting,
  onExited
}) => (
    <section className='home-page'>
      <Carousel
        interval={6000}
        slide={false}
        activeIndex={activeIndex}
        next={nextIndex}
        previous={previousIndex}>
        <CarouselIndicators
          items={artists}
          activeIndex={activeIndex}
          onClickHandler={setActiveIndex} />
        {
          fp.map((artist) => (
            <CarouselItem
              key={artist.id}
              onExiting={onExiting}
              onExited={onExited}>
              <Link to={routes.artist(artist.id)}>
                <img src={artist.src} alt={artist.altText} />
              </Link>
              <CarouselCaption className='d-block' {...artist.caption} />
            </CarouselItem>
          ))(artists)
        }
        <CarouselControl direction='prev' directionText='Previous' onClickHandler={previousIndex} />
        <CarouselControl direction='next' directionText='Next' onClickHandler={nextIndex} />
      </Carousel>
      <Container fluid>
        <Row className='mb-4'>
          {
            fp.map(({ link, src, title }) => (
              <Col key={title} xs={12} md={6} className='mt-4 mt-md-5'>
                <Card className='bg-dark'>
                  <Link to={link} className='text-white'>
                    <CardImg src={src} alt={title} />
                    <CardImgOverlay className='flex-center'>
                      <CardTitle className='h1-responsive'>{title}</CardTitle>
                    </CardImgOverlay>
                  </Link>
                </Card>
              </Col>
            ))([
              {
                link: routes.artists,
                src: artistsImg,
                title: 'Artists'
              },
              {
                link: routes.events,
                src: eventsImg,
                title: 'Events'
              }
            ])
          }
        </Row>
      </Container>
    </section>
  );

export default compose(
  withProps(({ match }) => ({
    filter: {
      international: true,
      leading: true
    }
  })),
  graphql(query),
  mapProps(({ data: { artists, ...otherData }, ...otherProps }) => ({
    ...otherProps,
    data: {
      ...otherData,
      artists: fp.flow(
        fp.shuffle,
        fp.take(5),
        fp.map(({ name, profileImage }) => ({
          id: fp.replace(/ /g, '_', name),
          src: profileImage,
          altText: name,
          caption: {
            captionText: name
          }
        }))
      )(artists)
    }
  })),
  withStateHandlers({
    animating: false,
    activeIndex: 0
  }, {
      setActiveIndex: () => (activeIndex) => ({ activeIndex }),
      nextIndex: ({ animating, activeIndex }, { data: { artists } }) => () => ({
        activeIndex: animating ?
          activeIndex :
          activeIndex === artists.length - 1 ?
            0 :
            activeIndex + 1
      }),
      previousIndex: ({ animating, activeIndex }, { data: { artists } }) => () => ({
        activeIndex: animating ?
          activeIndex :
          activeIndex === 0 ?
            artists.length - 1 :
            activeIndex - 1
      }),
      onExiting: () => () => ({ animating: true }),
      onExited: () => () => ({ animating: false })
    }),
  pure
)(Home);



// WEBPACK FOOTER //
// ./src/components/pages/home/home.js